import { Link } from "react-router-dom";
import { Briefcase, Scale, Megaphone, BookOpen, Download, ArrowRight, Newspaper, Mail, Phone } from "lucide-react";
import CountUp from "@/components/CountUp";

const SERVIZI = [
  { icon: Briefcase, titolo: "Consulenza HR", desc: "Consulenza in diritto del lavoro, organizzazione e diritti sindacali.", anchor: "consulenza-hr" },
  { icon: Scale, titolo: "Assistenza", desc: "Risoluzione stragiudiziale delle controversie di lavoro individuali e collettive.", anchor: "assistenza" },
  { icon: Megaphone, titolo: "Rappresentanza", desc: "Portiamo avanti gli interessi dei settori e delle aziende rappresentate.", anchor: "rappresentanza" },
  { icon: BookOpen, titolo: "Informazione e Networking", desc: "Costante servizio di informazione sulle novità normative.", anchor: "informazione" },
];

const FOCUS = [
  { id: "trasparenza-salariale", path: "/area-lavoro-welfare/trasparenza-salariale", titolo: "Trasparenza salariale", desc: "Decreto di recepimento della Direttiva UE 2023/970: novità, obblighi e materiali di approfondimento per le imprese.", image: "/local-assets/focus-trasparenza-salariale.webp" },
  { id: "flessibilita", path: "/area-lavoro-welfare/flessibilita-organizzativa", titolo: "Flessibilità organizzativa", desc: "Ottimizzare i processi e coinvolgere i dipendenti nella conciliazione dei tempi vita-lavoro.", image: "/local-assets/focus-flessibilita-organizzativa.webp" },
  { id: "welfare", path: "/area-lavoro-welfare/welfare-aziendale", titolo: "Welfare aziendale", desc: "Troviamo la soluzione ottimale per la tua impresa in tema welfare.", image: "/local-assets/focus-welfare-aziendale.webp" },
  { id: "assunzioni", path: "/area-lavoro-welfare/assunzioni-agevolate", titolo: "Assunzioni agevolate", desc: "Consulenza nella fase di assunzione del personale con incentivi e agevolazioni.", image: "/local-assets/focus-assunzioni-agevolate.webp" },
  { id: "contenzioso", path: "/area-lavoro-welfare/contenzioso-lavoro", titolo: "Contenzioso sul lavoro", desc: "Assistenza nella risoluzione stragiudiziale delle controversie di lavoro individuali e collettive.", image: "/local-assets/focus-contenzioso-lavoro.webp" },
  { id: "parita", path: "/area-lavoro-welfare/parita-genere", titolo: "Certificazioni per le imprese", desc: "Impegno autentico per l'inclusione e le pari opportunità, con certificazione UNI/PdR 125.", image: "/local-assets/focus-certificazioni-imprese.webp" },
];

const CONTENUTI_COLLEGATI = [
  {
    titolo: "RecruIT – AI per le Risorse Umane",
    tipo: "Progetto",
    url: "https://www.confcommercioroma.it/progetti/recruit-ai-per-le-risorse-umane/",
    image: "/local-assets/recruit-ai-banner.png",
  },
  {
    titolo: "Seconda Chance",
    tipo: "Progetto",
    url: "https://www.confcommercioroma.it/progetti/seconda-chance/",
    image: "/progetto-seconda-chance.webp",
  },
];

const NOTIZIE_COLLEGATE = [
  {
    titolo: "Rinnovato l'AEC per gli Agenti e Rappresentanti di Commercio",
    data: "5 Giugno 2025",
    tags: ["Notizie", "Lavoro e Welfare", "Rappresentanza"],
    url: "https://www.confcommercioroma.it/rinnovato-laec-per-gli-agenti-e-rappresentanti-di-commercio/",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&q=80&auto=format",
  },
  {
    titolo: "Job Day – Direzione Lavoro: un'opportunità per aziende e candidati",
    data: "26 Febbraio 2025",
    tags: ["Notizie", "Lavoro e Welfare"],
    url: "https://www.confcommercioroma.it/job-day-direzione-lavoro-unopportunita-per-aziende-e-candidati/",
    image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=600&q=80&auto=format",
  },
  {
    titolo: "Nuovo Contratto Integrativo Regionale e Protocollo speciale Giubileo: tutte le novità per il settore terziario nel Lazio",
    data: "20 Dicembre 2024",
    tags: ["Lavoro e Welfare", "Giubileo"],
    url: "https://www.confcommercioroma.it/nuovo-contratto-integrativo-regionale-e-protocollo-speciale-giubileo-tutte-le-novita-per-il-settore-terziario-nel-lazio-2/",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&q=80&auto=format",
  },
  {
    titolo: "Lavoro: tutela legalità e qualità, il patto del terziario per Roma e Lazio",
    data: "12 Dicembre 2024",
    tags: ["Notizie", "Contratto Nazionale del Lavoro", "Lavoro e Welfare"],
    url: "https://www.confcommercioroma.it/lavoro-tutela-legalita-e-qualita-il-patto-del-terziario-per-roma-e-lazio/",
    image: "https://images.unsplash.com/photo-1575505586569-646b2ca898fc?w=600&q=80&auto=format",
  },
  {
    titolo: "Accordo quadro sul lavoro in modalità agile nel settore privato",
    data: "17 Ottobre 2024",
    tags: ["Notizie", "Contratto Nazionale del Lavoro", "Lavoro e Welfare"],
    url: "https://www.confcommercioroma.it/accordo-quadro-sul-lavoro-in-modalita-agile-nel-settore-privato/",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&q=80&auto=format",
  },
  {
    titolo: "Welfare aziendale per il settore terziario laziale: aumentano i fondi",
    data: "15 Gennaio 2024",
    tags: ["Lavoro e Welfare"],
    url: "https://www.confcommercioroma.it/welfare-aziendale-per-il-settore-terziario-laziale-aumentano-i-fondi/",
    image: "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?w=600&q=80&auto=format",
  },
];

const EVENTI_COLLEGATI = [
  {
    giorno: "10",
    mese: "LUG",
    tipo: "Convegno",
    data: "10 Luglio 2025",
    titolo: "Roma Smart: il futuro del lavoro tra flessibilità e contrattazione collettiva",
    url: "https://www.confcommercioroma.it/eventi/roma-smart-il-futuro-del-lavoro-tra-flessibilita-e-contrattazione-collettiva/",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=80&auto=format",
  },
  {
    giorno: "22",
    mese: "MAG",
    tipo: "Workshop",
    data: "22 Maggio 2025",
    titolo: "Welfare contrattuale: dall'assistenza sanitaria al fondo pensione, vantaggi verso il bilancio di sostenibilità",
    url: "https://www.confcommercioroma.it/eventi/welfare-contrattuale-dall-assistenza-sanitaria-al-fondo-pensione-vantagi-verso-il-bilancio-di-sostenibilita/",
    image: "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?w=600&q=80&auto=format",
  },
  {
    giorno: "6",
    mese: "FEB",
    tipo: "Convegno",
    data: "6 Febbraio 2025",
    titolo: "Patto Giubileo per il lavoro 2025: le opportunità della Contrattazione Territoriale per le Imprese del Lazio",
    url: "https://www.confcommercioroma.it/eventi/patto-giubileo-per-il-lavoro-2025/",
    image: "https://images.unsplash.com/photo-1560439514-4e9645039924?w=600&q=80&auto=format",
  },
  {
    giorno: "10",
    mese: "DIC",
    tipo: "Evento",
    data: "10 Dicembre 2024",
    titolo: "Legalità e qualità del lavoro: il patto del terziario per Roma Capitale e la Regione Lazio",
    url: "https://www.confcommercioroma.it/eventi/legalita-e-qualita-del-lavoro-il-patto-del-terziario-per-roma-capitale-e-la-regione-lazio/",
    image: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=600&q=80&auto=format",
  },
];

export default function AreaLavoroWelfarePage() {
  return (
    <main id="main-content" data-testid="area-lavoro-welfare-page">
      {/* Hero with photo */}
      <section className="relative h-[320px] md:h-[380px] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=1920&q=60&auto=format" alt="Team al lavoro" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.82)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-12">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Per le aziende</span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mt-3 font-['Encode_Sans_Semi_Condensed'] tracking-tight">Area Lavoro e Welfare</h1>
          <p className="text-lg text-white/80 mt-4 max-w-3xl">Rappresentiamo le aziende associate nella trattativa e nella sottoscrizione dei principali Contratti Collettivi Nazionali di categoria e dei Contratti Territoriali Integrativi.</p>
        </div>
      </section>

      {/* Stats */}
      <section className="bg-white border-b border-[var(--confcom-border)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-[var(--confcom-border)]">
            {[
              { to: 2000, prefix: "", suffix: "+", label: "Aziende assistite" },
              { to: 40000, prefix: "~", suffix: "", label: "Rapporti di lavoro gestiti" },
              { to: 500, prefix: "", suffix: "+", label: "Vertenze stragiudiziali/anno" },
              { to: 200, prefix: "~", suffix: "", label: "Contratti integrativi firmati" },
            ].map((s) => (
              <div key={s.label} className="py-8 px-4 text-center">
                <div className="text-3xl font-bold text-[var(--confcom-blue)] font-['Encode_Sans_Semi_Condensed']">
                  {s.prefix}<CountUp to={s.to} />{s.suffix}
                </div>
                <div className="text-xs text-[var(--confcom-text-secondary)] mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cosa offriamo */}
      <section className="py-16 bg-[#EBF5FF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div id="servizi">
            <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-6">Cosa offriamo</h2>
            <div className="grid md:grid-cols-2 gap-4">
              {SERVIZI.map((s) => (
                <Link key={s.titolo} to={`/area-lavoro-welfare/servizi#${s.anchor}`} className="group flex gap-4 p-6 rounded-xl bg-white border border-[var(--confcom-border)] hover:border-[var(--confcom-blue)]/30 hover:shadow-md transition-all">
                  <div className="w-11 h-11 bg-[var(--confcom-bg-blue-light)] rounded-lg flex items-center justify-center shrink-0 group-hover:bg-[var(--confcom-blue)] transition-colors">
                    <s.icon size={22} className="text-[var(--confcom-blue)] group-hover:text-white transition-colors" aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-1 group-hover:text-[var(--confcom-blue)] transition-colors">{s.titolo}</h3>
                    <p className="text-sm text-[var(--confcom-text-secondary)]">{s.desc}</p>
                  </div>
                </Link>
              ))}
            </div>
            {/* CTA Brochure — pulsante blu centrato */}
            <div className="mt-8 flex justify-center">
              <a
                href="https://www.confcommercioroma.it/wp-content/uploads/2025/02/Scheda_Area-Lavoro-e-Welfare_26092024.pdf"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="brochure-cta"
                className="inline-flex items-center gap-2 bg-[var(--confcom-blue)] text-white px-7 py-3 rounded-md font-semibold hover:opacity-90 transition-opacity text-sm shadow-sm"
              >
                <Download size={16} aria-hidden="true" /> Sfoglia la brochure
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contrattazione collettiva — sezione dedicata su sfondo blu scuro, per darle massimo risalto (è la seconda "anima" della pagina) */}
      <section id="contrattazione" className="py-16 bg-[var(--confcom-blue)]" data-testid="section-contrattazione-collettiva">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            <div className="flex items-start gap-5 max-w-2xl">
              <div className="w-14 h-14 rounded-xl bg-white/10 flex items-center justify-center shrink-0">
                <Scale size={26} className="text-white" aria-hidden="true" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] mb-3">Contrattazione collettiva</h2>
                <p className="text-white/80 leading-relaxed">Consulta e scarica i principali CCNL sottoscritti da Confcommercio, insieme agli Accordi territoriali di Roma e Lazio.</p>
              </div>
            </div>
            <Link
              to="/area-lavoro-welfare/contrattazione-collettiva"
              className="shrink-0 inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-7 py-3.5 rounded-md font-bold hover:bg-white/90 transition-colors text-sm shadow-lg"
            >
              Scarica e consulta i principali CCNL <ArrowRight size={16} aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>

      {/* Focus — sfondo bianco, card con foto */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-8">I nostri focus</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {FOCUS.map((f) => (
              <Link key={f.id} to={f.path} className="group bg-white rounded-xl border border-[var(--confcom-border)] overflow-hidden hover:shadow-lg transition-all" data-testid={`focus-${f.id}`}>
                <div className="h-40 overflow-hidden">
                  <img src={f.image} alt={f.titolo} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                </div>
                <div className="p-6">
                  <h3 className="text-base font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2 group-hover:text-[var(--confcom-blue)] transition-colors">{f.titolo}</h3>
                  <p className="text-sm text-[var(--confcom-text-secondary)] leading-relaxed">{f.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Progetti collegati */}
      <section className="py-12 bg-[#EBF5FF]" data-testid="section-contenuti-collegati">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-6 flex items-center gap-2">
            <span className="w-1 h-6 bg-[var(--confcom-blue)] rounded-full inline-block" aria-hidden="true"></span>
            Progetti collegati
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {CONTENUTI_COLLEGATI.map((item) => (
              <a
                key={item.titolo}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col bg-white rounded-xl border border-[var(--confcom-border)] overflow-hidden hover:border-[var(--confcom-blue)]/40 hover:shadow-lg transition-all"
              >
                <div className="h-48 overflow-hidden shrink-0">
                  <img
                    src={item.image}
                    alt={item.titolo}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex flex-col justify-between gap-3 px-5 py-5 flex-1">
                  <div>
                    <span className="text-xs font-bold uppercase tracking-widest text-[var(--confcom-blue)] font-['Encode_Sans_Semi_Condensed']">{item.tipo}</span>
                    <p className="text-base font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] group-hover:text-[var(--confcom-blue)] transition-colors leading-snug mt-1">{item.titolo}</p>
                  </div>
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-[var(--confcom-blue)]">
                    Scopri di più <ArrowRight size={14} aria-hidden="true" />
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Notizie collegate */}
      <section className="py-12 bg-white" data-testid="section-notizie-collegate">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-6 flex items-center gap-2">
            <span className="w-1 h-6 bg-[var(--confcom-blue)] rounded-full inline-block" aria-hidden="true"></span>
            Notizie correlate
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {NOTIZIE_COLLEGATE.map((n) => (
              <a
                key={n.titolo}
                href={n.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col bg-white rounded-xl border border-[var(--confcom-border)] overflow-hidden hover:border-[var(--confcom-blue)]/40 hover:shadow-lg transition-all"
              >
                {/* Immagine */}
                <div className="h-44 overflow-hidden shrink-0">
                  <img
                    src={n.image}
                    alt={n.titolo}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                {/* Testo */}
                <div className="flex flex-col gap-2 px-5 py-4 flex-1">
                  <div className="flex flex-wrap gap-1.5">
                    {n.tags.map((tag) => (
                      <span key={tag} className="text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full bg-[var(--confcom-bg-blue-light)] text-[var(--confcom-blue)]">{tag}</span>
                    ))}
                  </div>
                  <p className="text-sm font-semibold text-[var(--confcom-text-primary)] leading-snug group-hover:text-[var(--confcom-blue)] transition-colors flex-1">{n.titolo}</p>
                  <span className="flex items-center gap-1.5 text-xs text-[var(--confcom-text-muted)] mt-1">
                    <Newspaper size={11} aria-hidden="true" /> {n.data}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Eventi collegati */}
      <section className="py-12 bg-[#EBF5FF]" data-testid="section-eventi-collegati">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-6 flex items-center gap-2">
            <span className="w-1 h-6 bg-[var(--confcom-blue)] rounded-full inline-block" aria-hidden="true"></span>
            Eventi di settore
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {EVENTI_COLLEGATI.map((e) => (
              <a
                key={e.titolo}
                href={e.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white rounded-xl border border-[var(--confcom-border)] overflow-hidden hover:shadow-lg transition-all"
              >
                <div className="h-44 overflow-hidden relative">
                  <img src={e.image} alt={e.titolo} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                  <div className="absolute top-4 left-4 w-16 h-16 bg-[var(--confcom-blue)] rounded-xl flex flex-col items-center justify-center text-white shadow-lg">
                    <span className="text-2xl font-bold font-['Encode_Sans_Semi_Condensed'] leading-none">{e.giorno}</span>
                    <span className="text-xs uppercase font-medium">{e.mese}</span>
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs font-medium text-[var(--confcom-blue)] bg-[var(--confcom-bg-blue-light)] px-2.5 py-1 rounded-md">{e.tipo}</span>
                    <span className="text-xs text-[var(--confcom-text-muted)]">{e.data}</span>
                  </div>
                  <h3 className="text-base font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] leading-snug group-hover:text-[var(--confcom-blue)] transition-colors mb-2">{e.titolo}</h3>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-[var(--confcom-blue)]">
                    Scopri di più <ArrowRight size={12} aria-hidden="true" />
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="/cta-background.jpg" alt="" className="w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 59, 117, 0.88)" }} />
        </div>
        <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Per maggiori informazioni</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight mt-3 mb-8">Contattaci</h2>

          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 text-left" data-testid="area-lavoro-welfare-contatti">
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2 text-white/80">
                <Mail size={14} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <a href="mailto:sindacale@confcommercioroma.it" className="hover:text-white transition-colors">sindacale@confcommercioroma.it</a>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <Phone size={14} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <a href="tel:+390668437221" className="hover:text-white transition-colors">Tel: 06 68437 221-290</a>
              </div>
            </div>
          </div>

          <Link
            to="/chi-siamo/struttura-tecnica#ufficio-lavoro-e-welfare"
            data-testid="area-lavoro-welfare-scopri-team"
            className="inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-6 py-3 rounded-md font-semibold hover:bg-white/90 transition-colors text-sm mt-8"
          >
            Scopri il Team <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
      </section>
    </main>
  );
}
